import { navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';

import { CustomModal } from '../../BrandCampaign/BrandCampaignHero';
import { HeadingCta } from '../../Generic/HeadingCtas';
import * as styles from '../../Generic/HeadingCtas.module.scss';
import { PrimaryLink } from '../Links';
import BlindForm from './BlindForm';
import EmbeddedMarketoForm from './EmbeddedMarketoForm';
import { BLIND_FORM_ID, useLeadFormEffect } from './formEffects';
import MarketoForm from './MarketoForm';

const BlindFormCta = ({ cta, bkColor, inheritColor }) => {
  const [open, setOpen] = useState(false);
  const [blindForm, setBlindForm] = useState(null);
  const { ready, displayGate, lead } = useLeadFormEffect(cta.modalContent.marketoFormId);

  let onClick = () => {
    if (displayGate) {
      document.body.style.overflow = 'hidden';
      setOpen(true);
    } else {
      navigate(cta.modalContent.onSuccessRedirectUrl);
    }
  };
  const handleClose = () => {
    document.body.style.overflow = 'unset';
    setOpen(false);
  };

  const onModalSuccess = (formId, downloadUrl) => {
    // Push to GTM:
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'content_download',
        formID: formId,
        downloadUrl: downloadUrl,
      });
    }
  };

  const onRendered = (formInstance) => {
    if (displayGate || !formInstance) return;
    setBlindForm(formInstance);
    formInstance.setValues({
      Email: lead?.email,
      FirstName: lead?.firstName,
      LastName: lead?.lastName,
      LeadId: lead?.id,
    });
  };

  const submitBlindLead = async () => {
    try {
      await blindForm.submit();
      navigate(cta.modalContent.onSuccessRedirectUrl);
    } catch (e) {
      console.error('Error submitting blind lead form:', e);
      if (typeof window !== 'undefined' && window.FS) {
        window.FS.event('Marketo Form', {
          type: 'Blind form submit failed',
          formID: BLIND_FORM_ID,
          error: JSON.stringify(e),
        });
      }
    }
  };

  if (!ready) {
    return (
      <PrimaryLink
        isButton={true}
        label={cta.linkText || 'Loading...'}
        onClick={() => {}}
        bkColor={bkColor}
        className={styles.loadingButton}
        inheritColor={inheritColor}
      />
    );
  }

  return (
    <React.Fragment>
      <div className={styles.hidden}>
        <EmbeddedMarketoForm formId={BLIND_FORM_ID} onRendered={onRendered} />
      </div>
      <HeadingCta
        isBlindClick={true}
        cta={cta}
        bkColor={bkColor}
        inheritColor={inheritColor}
        primaryClick={ready && !!lead ? submitBlindLead : onClick}
      />
      <CustomModal className={styles.modal} open={open} onClose={handleClose}>
        {process.env.GATSBY_USE_BLIND_FORM === 'true' && (
          // <BlindForm
          //   accessCtaLabel={cta.linkText}
          //   accessPrompt={
          //     <div style={{ color: 'black' }}>
          //       <h3>You're all set!</h3>
          //       <p>You’ve previously shared your information with us, so no need to fill out the form again.</p>
          //     </div>
          //   }
          //   onBlindSuccess={() => navigate(cta.modalContent.onSuccessRedirectUrl)}
          //   fallbackFormId={cta.modalContent.marketoFormId}
          // >
          <MarketoForm
            className={styles.form}
            formId={cta.modalContent.marketoFormId}
            redirectUrl={cta.modalContent.onSuccessRedirectUrl}
            onSuccess={() => onModalSuccess(cta.modalContent.marketoFormId, cta.modalContent.onSuccessRedirectUrl)}
          />
          // </BlindForm>
        )}
        {!process.env.GATSBY_USE_BLIND_FORM && (
          <MarketoForm
            className={styles.form}
            formId={cta.modalContent.marketoFormId}
            redirectUrl={cta.modalContent.onSuccessRedirectUrl}
            onSuccess={() => onModalSuccess(cta.modalContent.marketoFormId, cta.modalContent.onSuccessRedirectUrl)}
          />
        )}
      </CustomModal>
    </React.Fragment>
  );
};

export default BlindFormCta;
